var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSearchResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no_search_results_a",
    x1: "90.245%",
    x2: "40.606%",
    y1: "135.552%",
    y2: "14.693%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no_search_results_b",
    x1: "22.933%",
    x2: "63.995%",
    y1: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ACC1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no_search_results_c",
    x1: "22.933%",
    x2: "73.709%",
    y1: "100%",
    y2: "58.142%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ACC1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no_search_results_d",
    x1: "7.894%",
    x2: "63.995%",
    y1: "22.684%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ACC1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no_search_results_e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C6D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E5EFFD"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no_search_results_a)",
    d: "M61.935 50.648c-.357-10.083-27.049-7.81-37.345-6.837-10.296.972-11.231-12.84-2.347-14.894 8.883-2.053 24.993-.994 33.34-2.889 8.346-1.895-2.212-12.06 9.161-13.285 11.373-1.225 34.89-.09 41.9-.34 11.012-.39 16.662 12.658-2.63 13.25-5.32.163-6.388 11.755 11.57 8.57 11.27-1.997 33.38-2.043 37.98 3.058 2.64 2.927 1.725 10.791-2.812 15.134-3.37 3.225-14.09 3.854-18.288 4.6-9.85 1.75-7.904 11.138-4.545 13.07 7.949 4.575 29.764-4.058 30.348 8.503.259 5.55-19.59 6.446-27.729 6.378-19.96-.166-33.075 1.585-33.996-5.117-.924-6.728 12.404-2.187 11.747-10.459-.344-4.322.577-13.506-7.974-13.024 11.707-.66-37.897 7.9-38.38-5.718z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A1B8E3",
    d: "M16.61 65.186c12.984 3.637 22.447 4.179 28.387 1.624-6.262 5.442-11.25 7.862-14.965 7.261-5.572-.901-11.282-7.261-13.422-8.885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no_search_results_b)",
    d: "M.201.397h23.377c0 12.2 6.635 16.61 13.712 18.098-8.269 4.653-23.768 2.02-28.157-1.827C4.743 12.822 2.132 11.302.2.398z",
    transform: "translate(0 54)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A1B8E3",
    d: "M180.067 50.913a21.081 21.081 0 0 1 1.984 2.217c1.139 1.491 1.479 3.551 1.4 3.603-.432.284-2.901-1.353-3.384-2.683-.29-.798-.29-1.843 0-3.137z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no_search_results_c)",
    d: "M.377 14.99C6.052 11.12 9.027 6.298 9.302.524c1.49-.222 4.369.055 11.59 1.31.674.116.733 1.182.18 3.197 2.434.892 3.55 1.741 3.347 2.549-1.765 7-4.1 10.191-7.624 11.69-4.042.513-9.515-.913-16.418-4.28z",
    transform: "translate(159 49)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A1B8E3",
    d: "M63.754 27.846c.048.79.045 1.51-.008 2.162-.11 1.359-.93 2.637-.998 2.627-.372-.057-.908-2.141-.521-3.094.232-.571.741-1.136 1.527-1.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no_search_results_d)",
    d: "M.208 3.857c4.95.667 8.906-.492 11.866-3.478.914.604 2.334 2.152 5.625 6.34.306.39-.18.994-1.46 1.814.88 1.665 1.07 2.666.566 3.003-4.362 2.924-7.177 3.514-9.812 2.612C4.56 12.461 2.298 9.031.208 3.858z",
    transform: "translate(46 21)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no_search_results_b)",
    d: "M15.64.373C13.599 6.053 6.949 9.333.234 10.576c2.712 4.234 8.125 11.038 12.828 15.951.223.234 1.13.6 1.368.792 1.44 1.161 2.983.505 3.783.494 3.96-1.238 7.475-1.77 10.771-4.757 1.69-1.532 2.945-2.938 3.344-3.62-.985-3.001-5.86-5.631-16.686-19.063z",
    transform: "translate(104)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1B8E3",
    d: "M121.225 24.627c.076 1.664-2.855 3.187-4.53 1.553 1.796 1.718 3.393 1.972 4.718 1.968 1.325-.005 7.51.01 14.888-8.707-6.527 7.099-11.475 8.924-15.076 5.186z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no_search_results_e)",
    d: "M56.555 53.628l-2.627 2.61c-.526.521-1.375.521-1.86 0L38.445 42.67c-.445-.442-.526-1.164-.162-1.646l-3.76-3.733-.12.12c-.122.12-.243.201-.405.321-.04.04-.081.04-.081.08-8.287 6.223-20.091 5.58-27.651-1.886-8.247-8.189-8.247-21.475 0-29.624 8.247-8.189 21.587-8.189 29.834 0 7.721 7.667 8.206 19.83 1.415 28.059l3.76 3.733c.525-.321 1.212-.281 1.657.16l13.623 13.528c.526.522.526 1.364 0 1.846z",
    transform: "translate(68 31)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M94.155 67.89c-.404 0-.808-.282-.97-.683a1.051 1.051 0 0 1 .647-1.284c5.983-2.008 10.025-7.587 10.025-13.89 0-2.85-.808-5.619-2.385-7.987-.323-.482-.161-1.084.283-1.405.485-.321 1.092-.16 1.415.28 1.779 2.69 2.709 5.861 2.709 9.113 0 7.145-4.568 13.487-11.4 15.815-.122.04-.202.04-.324.04zM75.68 61.306c-.323 0-.686-.16-.848-.481a16.461 16.461 0 0 1-2.506-8.791c0-9.192 7.519-16.659 16.776-16.659 1.172 0 2.385.12 3.517.362.566.12.89.642.768 1.204-.121.562-.647.883-1.213.763-1.01-.201-2.061-.322-3.112-.322-8.126 0-14.756 6.583-14.756 14.652 0 2.73.768 5.419 2.224 7.747.283.482.161 1.084-.324 1.365a.894.894 0 0 1-.525.16zM81.785 66.966c-.162 0-.323-.04-.485-.12-1.577-.803-2.991-1.887-4.245-3.131a1 1 0 0 1 0-1.405 1.018 1.018 0 0 1 1.415 0 14.21 14.21 0 0 0 3.76 2.77c.485.24.687.883.444 1.364-.161.321-.525.522-.889.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636F92",
    d: "M124.555 84.628l-2.627 2.61a1.3 1.3 0 0 1-1.86 0L106.445 73.67c-.445-.442-.526-1.164-.162-1.646l-3.76-3.733-.12.12c.727-.602 1.293-1.244 3.152-3.05l3.76 3.733c.525-.321 1.213-.281 1.657.16l13.624 13.528a1.315 1.315 0 0 1-.04 1.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DCFA",
    d: "M124.555 84.628l-2.627 2.61a1.3 1.3 0 0 1-1.86 0L106.445 73.67c-.445-.442-.526-1.164-.162-1.646l2.991-2.97c.526-.322 1.213-.281 1.658.16l13.623 13.528c.526.562.526 1.364 0 1.886z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/no-search-results.809dde9d.svg";
export { ForwardRef as ReactComponent };